import {
    Button,
      Col,
      Flex,
      Form,
      Radio,
      Row,
      Select,
      Table,
      Tag,
      Typography
    } from "antd";
    import React, { useCallback, useState } from "react";
    import { useEffect } from "react";
    import { useDispatch, useSelector } from "react-redux";
    import { useNavigate } from "react-router-dom";
    import { useTranslation } from "react-i18next";
    import { getSystemSettingsAction } from "../../../../../../redux/services/addon-and-sponsorship/addonAndSponsorshipServices";
    import useDebounce from "../../../../../../hooks/useDebounce";
    import { appConstConfig } from "../../../../../../constants/config/appConstConfig";
    import { dateObjToDispViewDate } from "../../../../../../utils/utils";
    import { colors } from "../../../../../../constants/colors";
    import Spinner from "../../../../../common/spinner/Spinner";
    import { baseRouteMakerForSuperAdmin, routes } from "../../../../../../constants/routeConsts";
    import { ArrowLeftOutlined } from "@ant-design/icons";
    import styles from "./Addons.module.scss";
    
    const AddonsList = () => {
      /* i18n dependencies */
      const { t } = useTranslation();
      /* i18n dependencies */
    
      /* dispatch an action */
      const dispatch = useDispatch();
      /* dispatch an action */
    
      /* For navigating between pages */
      const navigate = useNavigate();
      /* For navigating between pages */
    
      /* form dependencies */
      const [form] = Form.useForm();
      /* form dependencies */
    
      /* loading dependencies */
      const [loading, setLoading] = useState(false);
      const [selectListLoader, setSelectListLoader] = useState(false);
      /* loading dependencies */
    
      /* table dependencies */
      const [columns, setColumns] = useState([]);
      const { tickets } = useSelector((state) => state.tickets);
      const [searchValue, setSearchValue] = useState("");
      const [pagination, setPagination] = useState({
        pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
        pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
      });
      const paginationObj = {
        total: tickets?.total,
        current: pagination?.pageNo,
        pageSize: pagination?.pageSize,
        onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
        pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
        showSizeChanger: true,
      };
      /* table dependencies */
    
      /* filter dependencies */
      const { debouncedValue: debouncedSearchValue, debounceLoading } = useDebounce(
        searchValue,
        500
      );
      const [selectedFilterStatus, setSelectedFilterStatus] = useState("addon");
      /* filter dependencies */
  
      const { systemSettings } = useSelector((state) => state.addonAndSponsorship);
    
      const handleGetTableData = useCallback(() => {
        dispatch(getSystemSettingsAction(setLoading));
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
    
      useEffect(() => {
        handleGetTableData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [selectedFilterStatus]);
  
    
      /* initial dependencies rendering */
      useEffect(() => {
        /* table column config */
        const tempTableColumns = [
          {
            title: t("Modules.Ads.srNo"),
            dataIndex: "index",
            key: "index",
            render: (_, record, index) => (
              <p>{index + 1}</p>
            ),
          },
          {
            title: t("Modules.Ads.duration"),
            dataIndex: "duration",
            key: "duration",
            render: (_, record) => (
              <p>{`${record?.duration} ${record?.duration_unit}`}</p>
            ),
          },
          {
            title: t("Modules.Ads.price"),
            dataIndex: "price",
            key: "price",
            render: (_, record) => (
              <p>{`${record?.price} ${systemSettings?.system_currency}`}</p>
            ),
          }
        ];
        /* table column config */
        setColumns(()=>{
          return selectedFilterStatus === "push_notification" ? tempTableColumns.filter((element)=>element.dataIndex !== "duration") : tempTableColumns
        });
      }, [selectedFilterStatus]);
      /* initial dependencies rendering */
  
    
      return (
        <div className={styles.adsListContainer}>
          <Flex vertical gap="2rem">
          <Flex justify="space-between">
            <Flex gap="1rem">
              <Button
                type="default"
                shape="circle"
                size="small"
                icon={<ArrowLeftOutlined />}
                onClick={() =>
                  navigate(baseRouteMakerForSuperAdmin(routes.ADDONS))
                }
              />
              <Typography.Title level={2}>
                {
                selectedFilterStatus === "addon" ? t("Modules.Addons.addonSponsoredAdCharges") : selectedFilterStatus === "push_notification" ? t("Modules.Addons.pushNotificationSponsoredAdCharges") : selectedFilterStatus === "promoted" ? t("Modules.Addons.promotedAdvertisementSponsoredAdCharges") : ""
                }
              </Typography.Title>
            </Flex>
            <Radio.Group
                  onChange={(event) => setSelectedFilterStatus(event.target.value)}
                  value={selectedFilterStatus}
                  options={[
                    { label: t("Modules.Addons.addonLogins"), value: "addon" },
                    { label: t("Modules.Addons.pushNotification"), value: "push_notification" },
                    // { label: t("Modules.Addons.promotedAdvertisement"), value: "promoted" }
                  ]}
                />
            </Flex>
                
            {loading || debounceLoading ? (
              <Spinner />
            ) : (
              <Table
                dataSource={selectedFilterStatus === "addon" ? systemSettings?.addon_account_charges : selectedFilterStatus === "push_notification" ? [{price:systemSettings?.single_push_notification_send_charges}] : selectedFilterStatus === "promoted" ? systemSettings?.promoted_sponsored_ad_charges : []}
                columns={columns}
                pagination={paginationObj}
              />
            )}
          </Flex>
        </div>
      );
    };
    
    export default AddonsList;
    